module.exports = __webpack_public_path__ + "img/semioad-original-480.cf04f15b.png";